import { LoadingSpinner } from "@/components/loading/LoadingSpinner";
import Box, { BoxProps } from "@mui/joy/Box";
import * as Layout from "../layout/Layout";

export const PageLoading = (props: BoxProps) => {
  return (
    <Layout.Main withPane={false}>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        height={"100%"}
        width={"100%"}
        {...props}
      >
        <LoadingSpinner />
      </Box>
    </Layout.Main>
  );
};
